import $ from "jquery";

const Field = (($) => {
  class Field {
    constructor(field) {
      this._element = null;
      this._form = null;
      this._messages = null;

      this._field = field;

      if (!this._field.settings) {
        this._field.settings = {};
      }

      if (typeof this._field.settings != "object") {
        this._field.settings = $.parseJSON(this._field.settings);
      }
    }

    getForm() {
      return this._form;
    }

    setForm(form) {
      this._form = form;
    }

    getElement() {
      return this._element;
    }

    getSlug() {
      return this._field.slug;
    }

    getValue() {
      let value = null;
      if (this._input && this._input.value) {
        value = this._input.value.trim();

        if (value.length == 0) {
          value = null;
        }
      }
      return value;
    }

    render() {}

    getSetting(name, defaultValue) {
      if (this._field && this._field[name]) {
        return this._field[name];
      }
      return defaultValue;
    }

    validate() {}

    appendMessage(message) {
      if (!this._messages) {
        return;
      }

      let messageBlock = document.createElement("div");
      messageBlock.innerText = message;
      this._messages.appendChild(messageBlock);

      this._element.classList.add("ion-is-invalid");
    }

    appendMessages(messages) {
      if (!this._messages) {
        return;
      }

      messages.forEach((message) => {
        this.appendMessage(message);
      });
    }

    clearMessages() {
      if (!this._messages) {
        return;
      }

      this._messages.innerHTML = "";
      this._element.classList.remove("ion-is-invalid");
    }

    _renderInstructions() {
      let instructions = this.getSetting("instructions");

      if (!instructions) {
        return false;
      }

      let instructionBlock = document.createElement("div");
      instructionBlock.classList.add("ion-form-instructions");
      instructionBlock.innerText = instructions;
      return instructionBlock;
    }

    _renderMessages() {
      this._messages = document.createElement("div");
      this._messages.classList.add("ion-form-messages");
    }
  }

  return Field;
})($);

export default Field;
